import { FormatMoney } from "format-money-js";

const fm = new FormatMoney();

export const formatMoney = ({
  amount,
  decimals = 2,
  symbol = " USDT",
  append = true,
}) => {
  return fm
    .from(amount, {
      decimals,
      separator: ",",
      decimalPoint: ".",
      symbol,
      append,
    })
    ?.toString();
};
